import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { Nullable } from '@src/types/utils';

import { ProductDialogStep } from '../../types';

import { PRODUCT_DIALOG_STEPS } from './constants';
import { WizardStepItem, WizardStepStatus } from './types';

@Component({
  selector: 'lp-product-steps-wizard',
  templateUrl: './product-steps-wizard.component.html',
  styleUrls: ['./product-steps-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductStepsWizardComponent extends BaseResizableComponent implements OnChanges {
  private readonly translateService = inject(TranslateService);

  @Input() steps: Array<ProductDialogStep> = [];
  @Input() step: Nullable<ProductDialogStep> = ProductDialogStep.Common;

  items: WizardStepItem[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['step']) {
      let completed = true;

      this.items = Object.entries(PRODUCT_DIALOG_STEPS)
        .filter(([step, caption]) => this.steps.includes(step as ProductDialogStep))
        .map<WizardStepItem>(([step, caption], index) => {
          let status: WizardStepStatus;

          if (step === this.step) {
            status = 'current';
            completed = false;
          } else {
            status = completed ? 'completed' : 'rest';
          }

          return {
            caption: this.translateService.instant(caption),
            status,
            step: step as ProductDialogStep,
            stepIndex: index + 1,
          };
        });

      if (this.isMobile) {
        this.items = this.items.filter(item => item.step === this.step);
      }
    }

    if (changes['steps']) {
      this.items = this.items.filter(item => this.steps.includes(item.step));
    }

    this.cdr.markForCheck();
  }

  afterChangeScreenType() {
    if (this.isMobile) {
      this.items = this.items.filter(item => item.step === this.step);
    }
  }
}
